module.exports = __webpack_public_path__ + "static/media/21.fe6513d5.png";